import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/shopware': {
    width: 495,
    height: 512,
    paths: [
      {
        d: 'M395.5 455.3C352.6 487.1 301.6 503.9 248 503.9 110.8 503.9 0 392.9 0 255.9 0 118.7 111 7.9 248 7.9 309.3 7.9 368.2 30.4 413.7 71.4 416.3 73.7 414.3 78 410.8 77.5 393.2 75.1 374.1 73.9 354.1 73.9 224.8 73.9 131.7 127.4 131.7 229.2 131.7 338.3 223.9 375.1 308.6 408 342.2 421 374 433.3 395.5 449.6 397.4 451 397.4 453.9 395.5 455.3zM495 232.9C494.9 232 494.4 231.1 493.7 230.5 441.9 187.5 400.1 170 349.2 170 265.1 170 269 222.2 269 223.7 269 266.3 321 285.7 381.3 308.1 412.4 319.7 444.5 331.7 474 348.1 475.9 349.1 478.2 348.3 479 346.3 497.9 297.9 497 256 495 232.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/shopware.js
// module id = VkFe
// module chunks = 144